import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "disabled", "children", "header", "isOpen", "onToggle", "paddingBlockEnd", "paddingBlockStart", "paddingInline"],
  _excluded2 = ["children", "position", "paddingInlineStart", "marginBlockStart", "insetBlockStart"],
  _excluded3 = ["children", "paddingBlock"];
import { createContext, useContext } from 'react';
import styled from 'styled-components';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { LayoutBox } from '../Layout/LayoutBox';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { useDisclosure } from '../useDisclosure';
import { jsx as _jsx } from "react/jsx-runtime";
export const AccordionContext = /*#__PURE__*/createContext({
  disabled: false
});

/**
 * @todo Remove this when Trellis has fixed alignment issues.
 *
 * The selector is also quite a hack, but we want to make sure we only pinpoint the
 * accordion header button and not any other button that might be present inside.
 */
const StyledAccordion = styled(LayoutBox).withConfig({
  displayName: "Accordion__StyledAccordion",
  componentId: "sc-8uy4um-0"
})(["& > div > [role='button']{margin-block-end:0;}"]);
export const Accordion = _ref => {
  let {
      as,
      disabled,
      children,
      header,
      isOpen,
      onToggle: providedOnToggle,
      paddingBlockEnd = 'space-sm',
      paddingBlockStart = 'space',
      paddingInline = 'space-md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isOpen: isOpenUncontrolled,
    onToggle
  } = useDisclosure({
    isOpen,
    onOpen: () => providedOnToggle === null || providedOnToggle === void 0 ? void 0 : providedOnToggle(true),
    onClose: () => providedOnToggle === null || providedOnToggle === void 0 ? void 0 : providedOnToggle(false)
  });
  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: {
      disabled
    },
    children: /*#__PURE__*/_jsx(StyledAccordion, Object.assign({}, rest, {
      forwardedAs: as,
      paddingBlockEnd: paddingBlockEnd,
      paddingBlockStart: paddingBlockStart,
      paddingInline: paddingInline,
      children: /*#__PURE__*/_jsx(AccordionItem, {
        disabled: disabled,
        flush: true,
        onOpenChange: onToggle,
        open: isOpenUncontrolled,
        size: "xs",
        title: header,
        children: children
      })
    }))
  });
};

/**
 * @todo Remove offset hacks when Trellis has fixed alignment issues
 */
const Header = _ref2 => {
  let {
      children,
      position = 'relative',
      paddingInlineStart = 'space-xs',
      marginBlockStart = '-space-3xs',
      insetBlockStart = '-space-4xs'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    disabled
  } = useContext(AccordionContext);
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    as: "span",
    flexGrow: 1,
    insetBlockStart: insetBlockStart,
    marginBlockStart: marginBlockStart,
    opacity: disabled ? 0.5 : 1,
    paddingInlineStart: paddingInlineStart,
    position: position,
    children: children
  }));
};
Accordion.Header = Header;
const Content = _ref3 => {
  let {
      children,
      paddingBlock = 'space-sm'
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    paddingBlock: paddingBlock,
    children: children
  }));
};
Accordion.Content = Content;